import { Currency } from '@kodiak-finance/sdk-core'
import { useConnection } from 'hooks/useConnection'
import { useMemo } from 'react'
import { useCombinedTokenList } from 'state/lists/hooks'

//
// Returns a WrappedTokenInfo from the active token lists when possible,
// or the passed token otherwise.
export function useTokenInfoFromActiveList(currency: Currency) {
  const { chainId } = useConnection()
  const activeList = useCombinedTokenList()

  return useMemo(() => {
    if (!chainId) return
    if (currency.isNative) return currency

    try {
      return activeList[chainId][currency.wrapped.address].token
    } catch (e) {
      return currency
    }
  }, [activeList, chainId, currency])
}
